import React, { useState } from 'react';
import { Menu, MenuItem, ListItemIcon, ListItemText } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';

import { SheetKinds } from '../redux/sheetDbSlice';
import { BlankMenuDataType } from './BookEditor';

type BlankMenuProps = {
  onClose: () => void;
  data: BlankMenuDataType;
  sheetKind: SheetKinds;
  addCard: () => void;
  pasteCard: () => void;
}
const BlankMenu: React.FC<BlankMenuProps> = ({ onClose, data, sheetKind, addCard, pasteCard }) => {
  const [enable, setEnable] = useState(false);
  const copying = data ? data.copying : 0;

  const addExe = () => {
    addCard();
    onClose();
  }
  const pasteExe = () => {
    if (copying >= 1) pasteCard();
    onClose();
  }

  return (
    <Menu open={Boolean(data)} onClose={onClose}
      style={{zIndex: 998, pointerEvents: enable ? 'auto' : 'none'}}
      elevation={4}
      anchorReference="anchorPosition"
      anchorPosition={data ? { top: data.y, left: data.x } : undefined}
    >
      <div style={{pointerEvents: 'all'}}
        onMouseOver={() => setEnable(true)}
        onMouseLeave={() => setEnable(false)}
      >
        <MenuItem onClick={addExe}>
          <ListItemIcon><AddIcon fontSize="small" /></ListItemIcon>
          <ListItemText>カードを追加する</ListItemText>
        </MenuItem>
        <MenuItem onClick={pasteExe} disabled={copying === 0 || (sheetKind !== 'story' && copying >= 2)}>
          <ListItemIcon><FileCopyOutlinedIcon fontSize="small" /></ListItemIcon>
          <ListItemText>{ copying >= 2 ? '行を貼り付ける' : 'カードを貼り付ける' }</ListItemText>
        </MenuItem>
      </div>
    </Menu>
  );
}

export default BlankMenu;
